import React from 'react';
import type { UserContext } from '@zola-helpers/client/dist/es/@types';
import insertInArrayIf from '@zola-helpers/client/dist/es/util/insertInArrayIf';
import type { MobileNavLink } from '../MobileNavMenuData';
import { Inbox } from '../../../Inbox';

const activeVendorsLinks = [
  { title: <Inbox />, path: '/wedding-vendors/inquiries' },
  { title: 'Your Booked Vendors', path: '/wedding-vendors/inquiries/booked' },
  {
    title: 'Your Favorites',
    path: '/favorites/home',
  },
];

export default function getMobileVendorsMenuData(userContext: UserContext): MobileNavLink[][] {
  const isGuest = Boolean(userContext.is_guest);
  const hasMarketplaceAccount = Boolean(userContext.has_marketplace_account);
  return [
    ...insertInArrayIf(hasMarketplaceAccount, activeVendorsLinks),
    [
      { title: 'Browse By Location', path: '/wedding-vendors' },
      { title: 'Wedding Venues', path: '/wedding-vendors/wedding-venues' },
      { title: 'Photographers', path: '/wedding-vendors/wedding-photographers' },
      { title: 'Videographers', path: '/wedding-vendors/wedding-videographers' },
      { title: 'Caterers', path: '/wedding-vendors/wedding-catering' },
      { title: 'Florists', path: '/wedding-vendors/wedding-florists' },
      { title: 'Beauty Professionals', path: '/wedding-vendors/wedding-hair-makeup' },
      { title: 'Wedding Planners', path: '/wedding-vendors/wedding-planners' },
      { title: 'Bands & DJs', path: '/wedding-vendors/wedding-bands-djs' },
      { title: 'Cakes & Desserts', path: '/wedding-vendors/wedding-cakes-desserts' },
      { title: 'Bar Services & Beverages', path: '/wedding-vendors/wedding-bar-services' },
    ],
    [
      ...insertInArrayIf(isGuest, {
        title: 'Become A Vendor',
        path: '/for-vendors',
      }),
      {
        title: 'Vendor FAQs',
        path: '/faq/category/360000467031-finding-vendors-real-weddings',
      },
    ],
  ];
}
